import type { MarkupMediaDialogProps } from "@dialogueconsulting/sked-preview";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "components/ui/dialog";

export function MarkupMediaDialog({
  open,
  onOpenChange,
  className,
  title,
  description,
  children,
}: MarkupMediaDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={className}
        contentWrapperMode="custom"
        contentWrapperClassName="min-h-0 flex-1 gap-3"
        onEscapeKeyDown={(event) => event.stopPropagation()}
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <DialogDescription className="sr-only">{description}</DialogDescription>
        {children}
      </DialogContent>
    </Dialog>
  );
}
